export const selectors = {
  btnNext: '.swiper-button-next-{id}',
  btnPrev: '.swiper-button-prev-{id}',
};

export function getDefaultNavigation(id: string) {
  return {
    disabledClass: 'navigatior-arrow-disable',
    nextEl: selectors.btnNext.replace('{id}', id),
    prevEl: selectors.btnPrev.replace('{id}', id),
  };
}

export { useSwiper, useSwiperSlide } from 'swiper/react';
